// extracted by mini-css-extract-plugin
module.exports = {"view":"ModalViewEventAnnouncement_view__L8N_f","disclaimer":"ModalViewEventAnnouncement_disclaimer__ELq__"};